import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DateFormatResolver, { fullDateUsFormat } from 'resolvers/date-format.resolver';
import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import {
	getPushNotification,
} from 'services/push-notification.service';
import { getImageByPath } from 'services/image.service';
import { parseImageNameFromPath, saveImageFromBlob } from 'utils/utils';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/icons
import CheckMark from 'assets/img/Checkmark.svg';
import Close from 'assets/img/Close.svg';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import NavPills from 'components/NavPills/NavPills';
import ReadOnlyField from 'components/ReadOnlyField/ReadOnlyField';
import AuditLog from 'components/AuditLog/AuditLog';

import styles from 'assets/jss/material-dashboard-pro-react/views/marketingEventLogStyles.js';

class MarketingEventLogDetails extends Component {

	state = {
		pushNotification: {
			sentResult: [{
				sent: false,
			}],
		},
		activeTabIndex: 0,
	};

	componentDidMount() {
		this.getRecordDetails();
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	onNavPillsChange = (state) => {
		this.setState({
			activeTabIndex: state.activeTabIndex || 0,
		});
	}

	async getRecordDetails() {
		try {
			const id = this.props.match?.params?.id;

			if (id) {
				this.setState({
					isLoading: true,
				});

				const pushNotification = await getPushNotification(id);
				this.props.setPageHeaderText(pushNotification?.type || '');
				this.setState(() => ({
					isLoading: false,
					pushNotification: pushNotification,
				}));
			}
		} catch (error) {
			console.log(error);
		}
	}

	downloadImage = async (e) => {
		e.preventDefault();
		const {
			pushNotification,
		} = this.state.pushNotification;
		const path = (pushNotification?.data || pushNotification)?.payload?.data?.marketingImage;

		const image = await getImageByPath(path);

		const name = parseImageNameFromPath(path);

		saveImageFromBlob(image, name);
	}

	render() {
		const {
			customerPhoneNumber,
			sentAt,
			sentToTokens,
			sentResult,
			sentResponse,
			createdBy,
			createdAt,
			modifiedBy,
			updatedAt,
			isSent,
		} = this.state.pushNotification;

		const { classes } = this.props;

		return (
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardBody>
							<NavPills
								color="warning"
								tabs={[
									{
										tabButton: 'Details',
										tabContent: (
											<div className="details-container">
												<div>
													<ReadOnlyField
														label="Sent at"
														value={DateFormatResolver.resolve(
															sentAt, fullDateUsFormat
														)}
													/>
													<ReadOnlyField
														label="Customer's phone number"
														value={
															customerPhoneNumber || ''
														}
													/>
													<ReadOnlyField
														label="Sent to Tokens"
														value={
															sentToTokens || ''
														}
													/>
													<ReadOnlyField
														label="Image Link"
														children={
															<span
																className={classes.imageLink}
																onClick={this.downloadImage}
															>
																Image
															</span>
														}
													/>
													<ReadOnlyField
														label="Sent"
														children={
															isSent
																? <img src={CheckMark} alt='Sent' />
																: <img src={Close} alt='Not Sent' />
														}
													/>
													<ReadOnlyField
														label="Sent Error"
														value={
															sentResult[0]
																.error || ''
														}
													/>
													<ReadOnlyField
														label="Sent Result"
														value={
															JSON.stringify(
																sentResponse
															) || ''
														}
													/>
												</div>
											</div>
										),
									},
									{
										tabButton: 'Sent Notification',
										tabContent: (
											<div>
												<ReactJson
													src={
														this.state
															.pushNotification
															?.pushNotification
													}
												/>
											</div>
										),
									},
									{
										tabButton: 'Audit Log',
										tabContent: (
											<AuditLog
												createdBy={createdBy}
												createdAt={createdAt}
												modifiedBy={modifiedBy}
												modifiedAt={updatedAt}
											/>
										),
									},
								]}
								onNavPillsChange={this.onNavPillsChange}
							/>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}

MarketingEventLogDetails.propTypes = {
	classes: PropTypes.any,
	setPageHeaderText: PropTypes.func,
	location: PropTypes.object,
	match: PropTypes.any,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch
	),
});

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(MarketingEventLogDetails)
);
